import { decryptData, encryptData, getUTFStr } from "./crypto"

export function saveToLocalStorage(key, data) {
  try {
    localStorage.setItem(key, encryptData(data));
  } catch (e) {
    console.warn(e);
  }
}
export function removeToLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn(e);
  }
}

export function loadFromLocalStorage(key) {
  try {
    const serialisedState = localStorage.getItem(key);

    if (serialisedState === null) return undefined;
    const result = JSON.parse(getUTFStr(decryptData(serialisedState.toString())));
    return (result)
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}